import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";

import { RedwoodProvider } from "@redwoodjs/web";
import { RedwoodApolloProvider } from "@redwoodjs/web/apollo";

import GoogleAnalyticsUserEvents from "src/components/GoogleAnalyticsUserEvents/GoogleAnalyticsUserEvents";
import { Toaster } from "src/components/ui/sonner";
import { ThemeProvider } from "src/lib/theme/ThemeProvider";
import FatalErrorPage from "src/pages/FatalErrorPage";
import Routes from "src/Routes";

import { AuthProvider, useAuth } from "./lib/auth";

import "./index.css";

if (process.env.NODE_ENV !== "development") {
  posthog.init(process.env.POSTHOG_KEY, {
    api_host: process.env.POSTHOG_HOST,
    defaults: "2026-01-30",
  });
}

const App = () => (
  <PostHogProvider client={posthog}>
    <PostHogErrorBoundary fallback={FatalErrorPage}>
      <RedwoodProvider titleTemplate="%PageTitle | %AppTitle">
        <AuthProvider>
          <GoogleAnalyticsUserEvents />
          <RedwoodApolloProvider useAuth={useAuth}>
            <ThemeProvider defaultTheme="dark" storageKey="ui-theme">
              <Routes />
              <Toaster />
            </ThemeProvider>
          </RedwoodApolloProvider>
        </AuthProvider>
      </RedwoodProvider>
    </PostHogErrorBoundary>
  </PostHogProvider>
);

export default App;
